import { vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["name", "id"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "switch" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "switch__line" }),
  /*#__PURE__*/_createElementVNode("span", { class: "switch__dot" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ww-switch", { 'is-active': _ctx.formValue, 'switch-mini': _ctx.mini}])
  }, [
    _createElementVNode("label", {
      class: _normalizeClass(["switch-item", { 'is-disabled': _ctx.disabled, 'form-property__label': _ctx.label }]),
      for: 'input' + _ctx.name,
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        name: 'input' + _ctx.name,
        id: _ctx.elName.default,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formValue) = $event)),
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
        class: _normalizeClass({ 'is-selected': _ctx.formValue })
      }, null, 42, _hoisted_2), [
        [_vModelCheckbox, _ctx.formValue]
      ]),
      _hoisted_3
    ], 10, _hoisted_1),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "switch__label",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
        }, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true)
  ], 2))
}